import React from 'react';
import { Typography, Button } from '@mui/material';
import { MainLayout } from '../../widgets';
import ContentLayout from '../../shared/ui/ContentLayout';
import Div from '../../shared/ui/Div';
import { UserRole } from '../../entities/user';
import styles from './styles';

const LingoLiftNotFoundPage = () => {
  return (
    <MainLayout userRole={UserRole.Public}>
      <ContentLayout>
        <Div
          sx={styles.container}
          role="main"
          aria-labelledby="not-found-title"
        >
          <Typography
            variant="h1"
            id="not-found-title"
            tabIndex={0}
          >
            404 - Page Not Found
          </Typography>
          <Typography
            variant="h4"
            sx={styles.message}
            aria-live="polite"
          >
            Sorry, the page you are looking for does not exist.
          </Typography>
          <Div sx={styles.buttonContainer}>
            <Button
              variant="contained"
              color="primary"
              href="/"
              sx={styles.button}
              aria-label="Return to homepage"
              tabIndex={0}
            >
              Go to Homepage
            </Button>
          </Div>
        </Div>
      </ContentLayout>
    </MainLayout>
  );
};

export default LingoLiftNotFoundPage;